<div class="machine-performances-wrapper">
    <app-machine-performance-list></app-machine-performance-list>
</div>